import type { RouteLocationRaw } from "vue-router";

// Custom innovadis code for getting the block settings
export function productHasVariations(product?: { hasVariations: boolean; variations: unknown[] }): boolean {
  return !!product && product.hasVariations && !!product.variations?.length;
}

export function getProductRoute(productId: string, productSlug?: string): RouteLocationRaw;
export function getProductRoute(productId?: string, productSlug?: string): RouteLocationRaw | undefined {
  const defaultRoute = productId ? { name: "Product", params: { productId } } : undefined;
  return productSlug ? `/${productSlug}` : defaultRoute;
}
